// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fc-timegrid-event {\n  background-color: transparent !important;\n  border-width: 2px;\n  /*border-color: lightgrey !important;*/\n}\n\n.customDatePickerWidth,\n.customDatePickerWidth > div.react-datepicker-wrapper,\n.customDatePickerWidth\n  > div\n  > div.react-datepicker__input-container\n  .customDatePickerWidth\n  > div\n  > div.react-datepicker__input-container\n  input {\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
